export default {
  "nav.logo": "Kakobuy Finds",
  "nav.subtitle": ".christmas",
  "nav.dropdown_placeholder": "Wybierz kategorię",
  "nav.kakobuy_sheet": "Kakobuy Sheet",

  "hero.h1_line1": "Kakobuy Spreadsheet",
  "hero.h1_line2": "Polska – Największa baza",
  "hero.h1_line3": "najlepszych znalezisk",
  "hero.subtitle": "Odkrywaj tysiące sprawdzonych produktów dzięki aktualnemu Kakobuy Spreadsheet. Znajdź najlepsze linki, trendy produkty i poradniki zakupowe w jednym miejscu.",
  "hero.cta_kakobuy": "Kakobuy Sheet",
  "hero.cta_buy": "Buy It Now",

  "categories.label": "Przeglądaj kategorie",
  "categories.title_line1": "Znajdź wszystko",
  "categories.title_line2": "czego potrzebujesz",

  "editorial.label": "Artykuł SEO",
  "editorial.title": "Kakobuy Spreadsheet Polska – Przewodnik 2026",
  "editorial.subtitle": "Kompletny poradnik dla początkujących i zaawansowanych użytkowników",
  "editorial.description": "Dowiedz się, czym jest Kakobuy Spreadsheet, jak z niego korzystać i dlaczego tysiące Polaków wybiera go jako główne źródło najlepszych znalezisk zakupowych. Poznaj wszystkie kategorie, triki i porady.",
  "editorial.cta": "Czytaj artykuł",
  "editorial.section_title": "Znaleziska i Poradniki",
  "editorial.section_desc": "Kakobuy Spreadsheet to starannie przygotowana baza najlepszych produktów, porównań i rekomendacji. Nasze artykuły pomogą Ci podejmować lepsze decyzje zakupowe i oszczędzać pieniądze.",
  "editorial.workspace_title": "Czym jest Kakobuy Spreadsheet?",
  "editorial.workspace_desc": "Kakobuy Spreadsheet to uporządkowana baza produktów zawierająca najlepsze znaleziska zakupowe, linki, kategorie oraz rekomendacje społeczności. Regularnie aktualizowana, pomaga zaoszczędzić czas i pieniądze.",

  "trust.label": "O Kakobuy Spreadsheet",
  "trust.title_line1": "Dlaczego warto",
  "trust.title_line2": "korzystać z arkusza?",
  "trust.description": "Kakobuy Spreadsheet to uporządkowana baza produktów zawierająca najlepsze znaleziska zakupowe, linki, kategorie oraz rekomendacje społeczności. Oszczędzaj czas, znajduj najlepsze produkty i kupuj świadomie dzięki gotowym listom i porównaniom.",
  "trust.link_text": "Przejdź do głównego sklepu →",
  "trust.stat1_value": "14+",
  "trust.stat1_label": "Kategorii",
  "trust.stat2_value": "1000+",
  "trust.stat2_label": "Znalezisk",
  "trust.guide1_title": "Jak wyszukiwać produkty",
  "trust.guide1_desc": "Użyj filtrów kategorii i słów kluczowych, aby szybko znaleźć idealne znalezisko w Spreadsheet.",
  "trust.guide2_title": "Bezpieczne zakupy z Chin",
  "trust.guide2_desc": "Sprawdź rating sprzedawcy, opinie użytkowników i zdjęcia QC przed złożeniem zamówienia.",
  "trust.guide3_title": "Porównanie przesyłek",
  "trust.guide3_desc": "Kakobuy oferuje najlepsze stawki wysyłkowe. Sprawdź różnice między liniami logistycznymi.",

  "cta.title": "Gotowy na zakupy?",
  "cta.subtitle": "Przeglądaj tysiące sprawdzonych produktów i znajdź najlepsze okazje",
  "cta.button": "Buy It Now",

  "testimonial.label": "(Opinie użytkowników)",
  "testimonial.title_line1": "Co mówią",
  "testimonial.title_line2": "nasi użytkownicy",
  "testimonial.quote": "Dzięki Kakobuy Spreadsheet zaoszczędziłam mnóstwo czasu na szukaniu produktów. Wszystko jest uporządkowane, a porównania pomagają mi podejmować lepsze decyzje zakupowe.",
  "testimonial.author": "Anna K., Warszawa",

  "footer.heading": "Kakobuy Finds",
  "footer.nav_title": "Nawigacja",
  "footer.nav_spreadsheet": "Kakobuy Spreadsheet",
  "footer.nav_finds": "Znaleziska",
  "footer.nav_comparisons": "Porównania",
  "footer.nav_guides": "Poradniki",
  "footer.nav_safety": "Bezpieczeństwo",
  "footer.social_title": "Social",
  "footer.newsletter_title": "Bądź na bieżąco",
  "footer.newsletter_subtitle": "Otrzymuj najnowsze znaleziska i aktualizacje",
  "footer.newsletter_placeholder": "Twój adres e-mail",
  "footer.newsletter_success": "Dziękujemy za zapisanie się!",
  "footer.newsletter_error": "Wystąpił błąd. Spróbuj ponownie.",
  "footer.newsletter_error_network": "Wystąpił błąd sieci. Spróbuj ponownie.",
  "footer.copyright": "© 2026 Kakobuy Finds. Wszelkie prawa zastrzeżone.",

  "categories.shoes": "Shoes",
  "categories.shoes_desc": "Najlepsze modele butów – od sneakersów po eleganckie obuwie",
  "categories.hoodies": "Hoodies / Sweaters",
  "categories.hoodies_desc": "Bluzy i swetry w najlepszych cenach i jakości",
  "categories.tshirts": "T-Shirts",
  "categories.tshirts_desc": "Koszulki od podstawowych po limitowane edycje",
  "categories.jackets": "Jackets",
  "categories.jackets_desc": "Kurtki na każdą porę roku – styl i funkcjonalność",
  "categories.pants": "Pants / Shorts",
  "categories.pants_desc": "Spodnie i szorty – wygoda i nowoczesny design",
  "categories.headwear": "Headwear",
  "categories.headwear_desc": "Czapki, kapelusze i akcesoria na głowę",
  "categories.sets": "Sets",
  "categories.sets_desc": "Komplety ubrań – gotowe stylizacje w jednym miejscu",
  "categories.underwear": "Underwear / Underpants",
  "categories.underwear_desc": "Bielizna najwyższej jakości w przystępnych cenach",
  "categories.jersey": "Jersey",
  "categories.jersey_desc": "Koszulki sportowe i trykoty dla każdego fana",
  "categories.accessories": "Accessories",
  "categories.accessories_desc": "Akcesoria, które dopełnią każdą stylizację",
  "categories.bags": "Bags",
  "categories.bags_desc": "Torby, plecaki i walizki – praktyczne i stylowe",
  "categories.belts": "Belts",
  "categories.belts_desc": "Paski skórzane i materiałowe – klasyka i nowoczesność",
  "categories.perfumes": "Perfumes",
  "categories.perfumes_desc": "Zapachy premium w najlepszych cenach na rynku",
  "categories.other": "Other Stuff",
  "categories.other_desc": "Wszystko, czego potrzebujesz – różnorodne produkty",
}